"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Home;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Home(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "home"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.768,48.293,54.132,10.657a5.849,5.849,0,0,0-8.264,0L8.232,48.291a2.5,2.5,0,0,0,3.536,3.535L49.4,14.192a.857.857,0,0,1,1.194,0L88.232,51.828a2.5,2.5,0,1,0,3.536-3.535Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51.764,20.1a2.5,2.5,0,0,0-3.528,0L15.589,52.6a2.5,2.5,0,0,0-.736,1.772V88.55a2.5,2.5,0,0,0,2.5,2.5h21.3a2.5,2.5,0,0,0,2.5-2.5V72.536H57.96V88.55a2.5,2.5,0,0,0,2.5,2.5H82.647a2.5,2.5,0,0,0,2.5-2.5V54.372a2.5,2.5,0,0,0-.736-1.772ZM80.147,86.05H62.96V70.036a2.5,2.5,0,0,0-2.5-2.5H38.653a2.5,2.5,0,0,0-2.5,2.5V86.05h-16.3V55.411L50,25.4l30.147,30.01Z"
  })))));
}